module.exports = __webpack_public_path__ + "img/welcomelanding_icon4.8e893e92.png";